// Scegli solo i componenti che ti servono
//import Alert from "bootstrap/js/dist/alert";
import Collapse from "bootstrap/js/dist/collapse";
//import Modal from "bootstrap/js/dist/modal";
// import Tooltip from "bootstrap/js/dist/tooltip"; // se usi Tooltip
// import Popover from "bootstrap/js/dist/popover"; // se usi Popover
